<script>
  export var settings;
  export var load;
  export var save;
  export var createRec;
  export var recs;
  export var openRec;

  import {
    Button,
  } from "sveltestrap";

  import TabPanel from "./TabPanel.svelte";
  import TabNav from "./TabNav.svelte";
  import SettingsAccount from "./SettingsAccount.svelte";
  import SettingsRecs from "./SettingsRecs.svelte";
  import SettingsDatasources from "./SettingsDatasources.svelte";
  import SettingsIntegrations from "./SettingsIntegrations.svelte";
  import SettingsKeys from "./SettingsKeys.svelte";
  import SettingsTeams from "./SettingsTeams.svelte";
  import SettingsQueries from "./SettingsQueries.svelte";
  // import Settings from "./settings"

  let activeTabId = "Data";
  //let ids = ["Account", "Reconciliations", "Data", "Queries", "Integrations", "Teams", "Keys"].map((x) => ({id:x,label:x}));
  let ids = ["Reconciliations", "Data", "Queries"].map((x) => ({id:x,label:x}));
</script>

<div style="background-color: #0002; " class="col p-2">
  <Button on:click={()=>{load()}}>Load</Button>
  <Button on:click={()=>save(settings)}>Save</Button>
  <!-- <Button on:click={()=>settings.modcount++}>{settings.modcount}</Button> -->

</div>

<div class="row pt-2">
  <div class="col-sm">
    <TabNav items={ids} bind:activeTabId tabs={false} name="settings">
      <div class="row pt-2">
        <div class="col-sm">
          <TabPanel tabId="Account">
            <SettingsAccount bind:settings={settings} />
          </TabPanel>
          <TabPanel tabId="Data">
            <SettingsDatasources 
              bind:settings={settings} 
              createRec={createRec}
              save={()=>save(settings)}
              />
          </TabPanel>
          <TabPanel tabId="Reconciliations">
            <SettingsRecs 
              bind:settings={settings} 
              bind:recs={recs}
              openRec={openRec} 
              />
          </TabPanel>
          <TabPanel tabId="Integrations">
            <SettingsIntegrations bind:settings={settings} />
          </TabPanel>
          <TabPanel tabId="Queries">
            <SettingsQueries bind:settings={settings} />
          </TabPanel>
          <TabPanel tabId="Teams">
            <SettingsTeams bind:settings={settings} />
          </TabPanel>
          <TabPanel tabId="Keys">
            <SettingsKeys bind:settings={settings} />
          </TabPanel>
        </div>
      </div>
    </TabNav>
  </div>
</div>
